import * as React from 'react';

import type { W_Notification_FindExpectedNotifyResult_VM } from 'ab-api/web/notification/findExpectedNotifyResult';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

import styles from './styles.module.scss';

interface Props {
	showModal: boolean;
	closeModal: () => void;
	expectedNotifyResult: W_Notification_FindExpectedNotifyResult_VM;
}

const ExpectedNotifyResultModal: React.FC<Props> = (props) => {

	const { showModal, closeModal, expectedNotifyResult } = props;

	const flattenedEmployeeAssignmentsThatMightNotBeNotified = expectedNotifyResult.employeeAssignmentsThatWontReceiveNotification
		.flatMap((_woa) => _woa.employeeFullNames
			.map((_eFN) => ({
				workOrderCode: _woa.workOrderCode,
				employeeFullName: _eFN,
			}))
		) ?? [];

	const flattenedTemporaryEmployeeAssignmentsThatMightNotBeNotified = expectedNotifyResult.temporaryEmployeeAssignmentsThatWontReceiveNotification
		.flatMap((_woa) => _woa.temporaryEmployeeFullNames
			.map((_teFN) => ({
				workOrderCode: _woa.workOrderCode,
				temporaryEmployeeFullName: _teFN,
			}))
		) ?? [];

	return (
		<CustomModal
			closeModal={closeModal}
			modalStyle="info"
			showModal={showModal}
			size="xl"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title="Notify Participants Result"
			/>
			<CustomModal.Body>
				Some laborers might not get a notification:
				<div className={styles['notification-result']}>
					{flattenedEmployeeAssignmentsThatMightNotBeNotified.map((_fwoa) => (
						<React.Fragment key={`${_fwoa.workOrderCode}-${_fwoa.employeeFullName}`}>
							<span>{_fwoa.employeeFullName}</span>
							<span className={styles['notification-result-work-order-code']}>{_fwoa.workOrderCode}</span>
						</React.Fragment>
					))}
					{flattenedTemporaryEmployeeAssignmentsThatMightNotBeNotified.map((_fwoa) => (
						<React.Fragment key={`${_fwoa.workOrderCode}-${_fwoa.temporaryEmployeeFullName}`}>
							<span>{_fwoa.temporaryEmployeeFullName}</span>
							<span className={styles['notification-result-work-order-code']}>{_fwoa.workOrderCode}</span>
						</React.Fragment>
					))}
				</div>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Close"
					onClick={closeModal}
					style="secondary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default React.memo(ExpectedNotifyResultModal);
